export enum ProcessBuildType {
  Cancel = 0,
  Rebuild = 1,
  Build = 2
}
